import * as ga4 from '@animaweb-js/components/ga4';
import './ga4';
import './glossary';
import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Popover from 'bootstrap/js/dist/popover';
import Scrollspy from 'bootstrap/js/dist/scrollspy';

window.addEventListener('load', function () {
    //
    // scroll tout en haut de la page lors de l'ouverture du menu
    //
    const open = document.querySelector('.hamburger.hamburger-open');

    if (open) {
        open.addEventListener('click', () => {
            window.scrollTo({
                behavior: 'smooth',
                top: 0,
            });
        });
    }

    //
    // fermeture des menus lors du redimensionnement de la fenêtre et lors du scroll vers le haut
    //
    let lastScroll = 0;

    function closeMenus() {
        const menus = document.querySelectorAll('#menu, #menu-duplicated');

        menus.forEach(menu => {
            const dropdown = menu.querySelector('.dropdown-menu.dropdown-menu-animate.show');
            const closeBtn = menu.querySelector('.hamburger.hamburger-close');

            if (dropdown && closeBtn) {
                closeBtn.click();
            }
        });
    }

    function handleScroll() {
        const currentScroll = window.scrollY;

        if (currentScroll < lastScroll) {
            closeMenus();
        }
    
        lastScroll = currentScroll;
    }

    window.addEventListener('resize', closeMenus);
    window.addEventListener('scroll', handleScroll);

    //
    // duplication du menu
    //
    function duplicate() {
        if (document.querySelector('#duplicate')) {
            if (window.innerWidth >= 984) {
                if (document.querySelector('#duplicated') === null) {
                    let clone = document.querySelector('#duplicate').cloneNode(true);
                    let logo = clone.querySelector('#logo');
                    let menu = clone.querySelector('#menu');
                    let menuLabel = menu.querySelector('#menuLabel');
                    let button = clone.querySelector('button[data-bs-target="#menu"]');

                    clone.removeAttribute('id');

                    logo.src = logo.src.replace('-white', '');
                    logo.removeAttribute('id');

                    clone.querySelectorAll('a').forEach(function (link) {
                        link.setAttribute('tabindex', '-1');
                    });

                    menu.setAttribute('id', menu.getAttribute('id') + '-duplicated');
                    menu.setAttribute('aria-labelledby', menu.getAttribute('aria-labelledby') + '-duplicated');

                    menuLabel.setAttribute('id', menuLabel.getAttribute('id') + '-duplicated');

                    button.setAttribute('data-bs-target', button.getAttribute('data-bs-target') + '-duplicated');
                    button.setAttribute('aria-controls', button.getAttribute('aria-controls') + '-duplicated');

                    let div = document.createElement('div');

                    div.appendChild(clone);
                    div.setAttribute('id', 'duplicated');
                    div.classList.add('bg-opacity-75', 'bg-white', 'blur', 'd-none', 'd-lg-block', 'header', 'max-w-100', 'position-fixed', 'top-0', 'w-100', 'z-4');

                    document.querySelector('#header').before(div);
                }
            } else if (document.querySelector('#duplicated')) {
                document.querySelector('#duplicated').remove();
            }
        }
    }

    duplicate();

    addEventListener('resize', () => {
        duplicate();
    });

    //
    // copie d'un lien
    //
    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new Popover(popoverTriggerEl));

    document.querySelectorAll('.copy').forEach(function (link) {
        link.addEventListener('click', function () {
            navigator.clipboard.writeText(link.getAttribute('data-url'));
        });
    });

    //
    // modification de la valeur cachée des champs "newsletter" et "tracking"
    //
    function changeHiddenValue(formName, inputCheckboxName) {
        const form = document.getElementById(formName);

        if (form) {
            const input = form.querySelector('input[name=' + formName + '-' + inputCheckboxName + ']');
            const inputHidden = form.querySelector('input[name=' + formName + '-' + inputCheckboxName + '-hidden]');

            if (input && inputHidden) {
                if (input.checked) {
                    inputHidden.value = 'true';
                } else {
                    inputHidden.value = '';
                }
            }
        }
    }

    changeHiddenValue('contact-form', 'newsletter');

    if (document.querySelector('#contact-form input[name=contact-form-newsletter]')) {
        document.querySelector('#contact-form input[name=contact-form-newsletter]').addEventListener('change', function () {
            changeHiddenValue('contact-form', 'newsletter');
        });
    }

    changeHiddenValue('contact-form', 'tracking');

    if (document.querySelector('#contact-form input[name=contact-form-tracking]')) {
        document.querySelector('#contact-form input[name=contact-form-tracking]').addEventListener('change', function () {
            changeHiddenValue('contact-form', 'tracking');
        });
    }

    changeHiddenValue('newsletter-form', 'tracking');

    if (document.querySelector('#newsletter-form input[name=newsletter-form-tracking]')) {
        document.querySelector('#newsletter-form input[name=newsletter-form-tracking]').addEventListener('change', function () {
            changeHiddenValue('newsletter-form', 'tracking');
        });
    }

    //
    // masquage des champs dépendants
    //
    function hideTriggeredField(formName, inputName) {
        const form = document.getElementById(formName);

        if (form) {
            const field = form.querySelector('[data-trigger="' + formName + '-' + inputName + '"]');

            if (field) {
                field.classList.add('d-none');
            }
        }
    }

    //
    // validation puis soumission des formulaires
    //
    function submitForm(formName) {
        const form = document.getElementById(formName);

        if (form) {
            const submit = form.querySelector('button[type=submit]');

            if (submit) {
                submit.addEventListener('click', function (event) {
                    if (!form.classList.contains('validated')) {
                        event.preventDefault();

                        if (form.checkValidity()) {
                            if (document.querySelector('body').classList.contains('local') || !form.classList.contains('form-recaptcha')) {
                                form.classList.add('validated');
                                submit.click();
                            } else {
                                if (form.querySelector('.response')) {
                                    grecaptcha.enterprise.ready(() => {
                                        grecaptcha.enterprise.execute(global.form_recaptcha_key, {
                                            action: 'submit',
                                        }).then(token => {
                                            document.querySelector('.response').value = token;
                                            form.requestSubmit();
                                        });
                                    });
                                } else {
                                    form.classList.add('validated');
                                    submit.click();
                                }
                            }
                        } else {
                            form.classList.add('was-validated');
                        }
                    }
                });
            }
        }
    }

    //
    // envoi des formulaires vers brevo
    //
    function sendForm(formName) {
        const form = document.getElementById(formName);

        if (form) {
            form.addEventListener('submit', function (event) {
                event.preventDefault();

                const data = new FormData(event.target);
                const email = data.get(formName + '-email');
                const givenname = data.get(formName + '-given-name');
                const familyname = data.get(formName + '-family-name');
                const organization = data.get(formName + '-organization');
                const siret = data.get(formName + '-siret');
                const revenue = data.get(formName + '-revenue');
                const numberofemployees = data.get(formName + '-number_of_employees');
                const tel = data.get(formName + '-tel');
                const message = data.get(formName + '-message');
                const response = data.get('response');

                const newsletter = data.get(formName + '-newsletter-hidden');
                const tracking = data.get(formName + '-tracking-hidden');

                let _data = {
                    action: 'form_' + formName,
                    email: email,
                    response: response,
                };

                if (givenname) {
                    _data.givenname = givenname;
                }

                if (familyname) {
                    _data.familyname = familyname;
                }

                if (organization) {
                    _data.organization = organization;
                }

                if (siret) {
                    _data.siret = siret;
                }

                if (revenue) {
                    _data.revenue = revenue;
                }

                if (numberofemployees) {
                    _data.number_of_employees = numberofemployees;
                }

                if (tel) {
                    _data.tel = tel;
                }

                if (message) {
                    _data.message = message;
                }

                if (newsletter) {
                    _data.newsletter = newsletter;
                }

                if (tracking) {
                    _data.tracking = tracking;
                }

                fetch('/wp-admin/admin-ajax.php', {
                    method: 'POST',
                    body: (new URLSearchParams(_data)).toString(),
                    headers: { 'Content-type': 'application/x-www-form-urlencoded' }
                })
                .then(response => response.text())
                .then(response => {
                    let alertMessage = document.querySelector('.alert-success');

                    if (alertMessage) {
                        document.querySelector('.alert-success').remove();
                    }

                    form.insertAdjacentHTML('beforeBegin', response);

                    form.reset();
                    form.classList.remove('validated', 'was-validated');

                    changeHiddenValue('newsletter-form', 'tracking');
                    changeHiddenValue('contact-form', 'tracking');
                    changeHiddenValue('contact-form', 'newsletter');
                    hideTriggeredField('contact-form', 'newsletter');

                    ga4.elementGtagEvent('#alert-contact', 'page_contact_submited', 'Contact - Envoyé', { category: 'page_view' });

                    Brevo.push(function () {
                        Brevo.identify({
                            identifiers: {
                                email_id: email,
                            },
                        });
                    });
                });
            });
        }
    }

    submitForm('contact-form');
    sendForm('contact-form');

    submitForm('newsletter-form');
    sendForm('newsletter-form');

    submitForm('telechargement-form');
    sendForm('telechargement-form');

    submitForm('test-form');
    sendForm('test-form');
});

// gestion de la navigation dans les formulaires à plusieurs étapes
const answersHistory = {};

document.addEventListener('DOMContentLoaded', function () {
    initializeCheckboxValidation();

    document.addEventListener('click', function (event) {
        if (event.target.matches('.btn-next, .btn-prev')) {
            const questionGroup = event.target.closest('.form-group');

            if (!questionGroup) {
                return;
            }

            const form = questionGroup.dataset.form;
            const color = questionGroup.dataset.color;
            const questionIndex = questionGroup.dataset.questionIndex;

            const formElement = questionGroup.closest('form');

            const data = new FormData();

            data.append('action', 'load_next_question');
            data.append('form', form);
            data.append('color', color);

            if (event.target.matches('.btn-next')) {
                const inputs = questionGroup.querySelectorAll('input, select, textarea');
                const checkboxGroup = questionGroup.querySelector('.checkboxes');

                if (formElement) {
                    if (formElement.checkValidity()) {
                        if (checkboxGroup) {
                            const minRequired = parseInt(checkboxGroup.dataset.min);
                            const maxRequired = parseInt(checkboxGroup.dataset.max);

                            const hasMin = !isNaN(minRequired);
                            const hasMax = !isNaN(maxRequired);

                            const checkboxes = checkboxGroup.querySelectorAll('input[type="checkbox"]');
                            const checkedCount = Array.from(checkboxes).filter(cb => cb.checked).length;

                            if ((hasMin && checkedCount < minRequired) || (hasMax && checkedCount > maxRequired)) {
                                checkboxGroup.classList.add('checkboxes-validated');
                                checkboxes.forEach(cb => cb.classList.add('checkbox-invalid'));
                                return;
                            } else {
                                checkboxes.forEach(cb => cb.classList.remove('checkbox-invalid'));
                            }
                        }

                        formElement.classList.remove('was-validated');
                    } else {
                        formElement.classList.add('was-validated');
                        return;
                    }
                }

                let answer = null;

                if (inputs.length === 1 && (inputs[0].type !== 'radio' && inputs[0].type !== 'checkbox' && inputs[0].tagName !== 'SELECT')) {
                    answer = inputs[0].value;
                } else {
                    answer = [];

                    inputs.forEach((input, index) => {
                        if (input.type === 'radio' || input.type === 'checkbox') {
                            if (input.checked) {
                                const parent = input.closest('.form-group');
                                const options = Array.from(parent.querySelectorAll('input'));
                                const optionIndex = options.indexOf(input);
                                answer.push(optionIndex);
                            }
                        } else if (input.tagName === 'SELECT') {
                            const selectedOptionIndex = input.selectedIndex;
                            answer.push(selectedOptionIndex);
                        }
                    });

                    answer = answer.join('|');
                }

                answersHistory[questionIndex] = answer;

                data.append('question_index', questionIndex);
                data.append('answer', answer);
            } else if (event.target.matches('.btn-prev')) {
                if (questionIndex <= 0) {
                    return;
                }

                formElement.classList.remove('was-validated');

                Object.keys(answersHistory).forEach((key) => {
                    if (parseInt(key) >= questionIndex) {
                        delete answersHistory[key];
                    }
                });

                data.append('go_back', 'true');
            }

            data.append('all_answers', JSON.stringify(answersHistory));

            fetch('/wp-admin/admin-ajax.php', {
                method: 'POST',
                body: data,
            })
            .then(response => response.text())
            .then(function (responseText) {
                document.getElementById('question-container').innerHTML = responseText;
                initializeCheckboxValidation();
            })
            .catch(function (error) {
                console.error('Erreur AJAX :', error);
            });
        }
    });
});

// initialisation de la validation des cases à cocher à chaque modification
function initializeCheckboxValidation() {
    document.querySelectorAll('.checkboxes').forEach(checkboxGroup => {
        const checkboxes = checkboxGroup.querySelectorAll('input[type="checkbox"]');

        const minRequired = parseInt(checkboxGroup.dataset.min);
        const maxRequired = parseInt(checkboxGroup.dataset.max);

        const hasMin = !isNaN(minRequired);
        const hasMax = !isNaN(maxRequired);

        checkboxes.forEach(cb => {
            cb.addEventListener('change', () => {
                const checkedCount = Array.from(checkboxes).filter(c => c.checked).length;

                if ((hasMin && checkedCount < minRequired) || (hasMax && checkedCount > maxRequired)) {
                    checkboxes.forEach(c => c.classList.add('checkbox-invalid'));
                } else {
                    checkboxes.forEach(c => c.classList.remove('checkbox-invalid'));
                }
            });
        });
    });
}